module.exports = __webpack_public_path__ + "img/alert-circle-pink.81a4eebf.svg";